import React from "react";

const UnreadNotificationicon = (props:any) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3891_8738)">
        <g opacity="0.8">
          <path
            opacity="0.8"
            d="M11.4417 17.9998C11.2952 18.2524 11.0849 18.462 10.8319 18.6078C10.5788 18.7535 10.292 18.8302 10 18.8302C9.70802 18.8302 9.42116 18.7535 9.16815 18.6078C8.91513 18.462 8.70484 18.2524 8.55833 17.9998M15 7.1665C15 5.84042 14.4732 4.56865 13.5355 3.63097C12.5979 2.69329 11.3261 2.1665 10 2.1665C8.67392 2.1665 7.40215 2.69329 6.46447 3.63097C5.52678 4.56865 5 5.84042 5 7.1665C5 12.9998 2.5 14.6665 2.5 14.6665H17.5C17.5 14.6665 15 12.9998 15 7.1665Z"
            stroke={props?.color ?? "black"}
            stroke-width="0.833333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <g filter="url(#filter0_i_3891_8738)">
          <rect
            x="12"
            y="0.5"
            width="6.66667"
            height="8"
            rx="3.33333"
            fill={props?.color ?? "black"}
          />
          <rect
            x="12.5"
            y="1"
            width="5.66667"
            height="7"
            rx="2.83333"
            stroke="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_3891_8738"
          x="12"
          y="0.5"
          width="6.66602"
          height="8"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3891_8738"
          />
        </filter>
        <clipPath id="clip0_3891_8738">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UnreadNotificationicon;
